var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Чтобы заполнить контент нажмите на \"открыть редактор\"")]),_c('button',{staticClass:"btn btn-info mb-4",on:{"click":function($event){return _vm.$store.dispatch('setPost',_vm.id)}}},[_vm._v("Открыть редактор")])])}
var staticRenderFns = []

export { render, staticRenderFns }